'use client'

// @ts-strict-ignore
import { FC, MouseEventHandler, useEffect, useState } from 'react'

import { useYaPayButtonClick } from '@/features/YaSplit/hooks/useYaPayButtonClick/useYaPayButtonClick'

import { useCart } from '@/entities/cart'

import { YaPaySplitButton } from '../YaPaySplitButton/YaPaySplitButton'

type YaPaySplitFastButtonProps = {
	id: number
	orderSource?: string
}

export const YaPaySplitFastButton: FC<YaPaySplitFastButtonProps> = ({ id, orderSource }) => {
	const { products } = useCart()
	const [idList, setIdList] = useState<number[]>([])
	const { onClick } = useYaPayButtonClick(orderSource)

	const onClickHandler: MouseEventHandler<HTMLElement> = e => {
		onClick(e.currentTarget, idList)
	}

	useEffect(() => {
		const filteredItems = products.filter(({ RELATED_PRODUCTS }) => RELATED_PRODUCTS === id)

		const newIdList = filteredItems.map(({ ID }) => ID).concat([id])

		setIdList(newIdList)
	}, [products, id])

	return <YaPaySplitButton onClick={onClickHandler} />
}
